export const welcomeBack = 'Welcome Back!';
export const orText = 'OR';
export const buttonText = 'LOGIN';
export const buttonSubmittingText = 'LOGGING IN...';
export const forgotPasswordText = 'Forgot password?';
